<div class="glippy-product-suggestion" *ngIf="data">
  <div class="glippy-product-suggestion__header">
    <span>{{ data.header }}</span>
    <button
      type="button"
      class="glippy-product-suggestion__add-all"
      (click)="addAllToCart()"
      [disabled]="cards.length === 0"
    >
      <i class="fas fa-cart-plus"></i>
      {{ 'GLIPPY_ADD_ALL_TO_CART' | translate }}
    </button>
    <button
      type="button"
      class="glippy-product-suggestion__toggle"
      (click)="toggleExpanded()"
      [attr.aria-expanded]="expanded"
    >
      {{ 'GLIPPY_EXPAND_INFO' | translate }}
      <i class="fas" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
  </div>
  <div
    class="glippy-product-suggestion__card"
    *ngFor="let card of cards"
  >
    <div class="glippy-product-suggestion__row">
      <span class="glippy-product-suggestion__media" *ngIf="expanded">
        <img
          *ngIf="card.product.extra?.images?.length > 0"
          class="glippy-product-suggestion__image"
          [src]="
            card.product.extra.images[0].s3Uri
              | gungImageUrl: 'type:thumbnail' : 'etag:' + card.product.extra.images[0].s3ETag
          "
          [alt]="card.product.name"
        />
      </span>
      <span class="glippy-product-suggestion__identity">
        <span class="glippy-product-suggestion__name" [title]="card.product.name">{{ card.product.name }}</span>
        <span class="glippy-product-suggestion__id">{{ card.product.id }}</span>
      </span>
      <span class="glippy-product-suggestion__metrics">
        <lib-availability
          *ngIf="card.availability"
          [availability]="card.availability"
          [isSales]="false"
        ></lib-availability>
        <lib-price
          *ngIf="card.price"
          [price]="card.price"
          type="NET"
          [currency]="card.price.customerNetPrice.currencyCode"
        ></lib-price>
      </span>
      <span class="glippy-product-suggestion__actions">
        <span class="glippy-product-suggestion__suggested" *ngIf="card.suggestedQty > 1">
          {{ 'GLIPPY_SUGGESTED_QTY' | translate }}: {{ card.suggestedQty }}
        </span>
        <lib-buy-button-wrapper
          [id]="card.product.id"
          [product]="card.product"
          [availability]="card.availability"
        ></lib-buy-button-wrapper>
      </span>
    </div>
    <div class="glippy-product-suggestion__details" *ngIf="expanded && card.product.description">
      <span class="glippy-product-suggestion__description">
        {{ card.product.description }}
      </span>
    </div>
  </div>
</div>
